import Breadcrumb from "components/Common/Breadcrumb"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import React from "react"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import toast from "react-hot-toast"
import KycDocumentUpload from "pages/KYC/kycDocumentUpload"
import { useCreateDocumentMutation } from "store/api/documents/documents"
import { documentTypes } from "helpers/utils"

const CreateDocument = ({ user_type }) => {
  const [mutate, { isLoading }] = useCreateDocumentMutation()
  const navigate = useNavigate()

  //meta title
  document.title = "Upload Document | Prachay"

  const createDoc = async (values) => {
    try {
      const { success, message } = await mutate({
        ...values,
        user_type,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "docSuccess" })
        navigate(
          user_type === "INVESTOR"
            ? "/resources/sample-documents"
            : "/wp-documents"
        )
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      document: "",
      status: "",
      docType: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await createDoc(values)
    },
  })

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"Upload Document"} breadcrumbItem={"Document"} />

        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <Form
                  className="form-horizontal"
                  onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row className="mb-2">
                    <Col sm={6} className="mb-2">
                      <Label className="form-label">
                        Document Title<span className="error">*</span>
                      </Label>
                      <Input
                        name="title"
                        className="form-control"
                        placeholder={"Enter Document Title"}
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title}
                        invalid={
                          validation.touched.title && validation.errors.title
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.title}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col xl={6} className="mb-2">
                      <Label className="form-label">
                        Status<span className="error">*</span>
                      </Label>
                      <select
                        name="status"
                        className="form-select pageSize mb-2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.status}
                      >
                        <option>Select Status</option>
                        {[
                          { label: "ACTIVE", value: "ACTIVE" },
                          { label: "DISABLE", value: "DISABLE" },
                        ].map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback type="invalid">
                          {validation.errors.status}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col sm={6}>
                      <Label className="col-form-label">
                        Document<span className="error">*</span>
                      </Label>
                      <KycDocumentUpload
                        placeholder="Select Document"
                        fieldKey={"document"}
                        validateMaxSize={false}
                        validation={validation}
                        extensionAllowedInput=".pdf"
                        extensionAllowed={["application/pdf"]}
                        typeError="Please upload file in PDF format only."
                      />
                    </Col>

                    <Col xl={6} className="mb-2">
                      <Label className="col-form-label">
                        Document Type<span className="error">*</span>
                      </Label>
                      <select
                        name="docType"
                        className="form-select pageSize mb-2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.docType}
                      >
                        <option>Select Document Type</option>
                        {documentTypes.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {validation.touched.docType &&
                      validation.errors.docType ? (
                        <FormFeedback type="invalid">
                          {validation.errors.docType}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>

                  <Row className="justify-content-end mt-4">
                    <Col sm={12}>
                      <div className="d-flex justify-content-end align-items-center gap-3">
                        <Button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinners /> : "Upload Document"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CreateDocument
